/** Presets accepted by `POST /api/disposable/aliases` (default 30m). */
export const DISPOSABLE_TTL_OPTIONS: { value: string; label: string }[] = [
	{ value: "30m", label: "30 minutes" },
	{ value: "60m", label: "60 minutes" },
	{ value: "90m", label: "90 minutes" },
	{ value: "6h", label: "6 hours" },
	{ value: "12h", label: "12 hours" },
	{ value: "24h", label: "24 hours" },
	{ value: "7d", label: "7 days" },
];

export function disposableTtlLabel(value: string): string {
	return DISPOSABLE_TTL_OPTIONS.find((o) => o.value === value)?.label ?? value;
}

/** Page size for `GET /api/disposable/messages` (must stay in sync with inbox UI). */
export const DISPOSABLE_INBOX_PAGE_SIZE = 25;

export type DisposableStats = {
	aliases_created: number;
	messages_received: number;
	/** Hostnames from `DISPOSABLE_MAIL_DOMAIN` (comma-separated list counts each). */
	domains_offered?: number;
};

export type DisposableLookup =
	| { status: "not_found" }
	| { status: "destroyed"; local_part: string }
	| {
			status: "active";
			local_part: string;
			expires_at: string;
			address: string;
			mail_domain: string;
	  };

export type DisposableMessage = {
	id: string;
	from: string;
	subject: string;
	text_body: string;
	html_body: string;
	received_at: string;
};

export type DisposableMessagesPage = {
	status: string;
	messages: DisposableMessage[];
	page: number;
	limit: number;
	total: number;
	total_pages: number;
	/** Echo of applied search (subject / from), when non-empty. */
	query?: string;
};

export type CreateAliasResponseData = {
	address: string;
	local_part: string;
	expires_at: string;
	mail_domain: string;
};
